<script>

import NewArticle from "@/views/components/cms/new/NewArticle.vue";

export default {
  name: "SonstigesNew",
  components: {
    NewArticle,
  },
}
</script>

<template>
  <NewArticle :category-id=6></NewArticle>
</template>

<style scoped>

</style>
